import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../apps/stocks-edit-profile-modal-app/stocks-edit-profile-modal.component";
import * as i2 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
export class StocksEditProfileModalButtonComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.defaultInfoFields = JSON.parse(this.eltRef.nativeElement.getAttribute('defaultInfoFields'));
        this.infoFields = JSON.parse(this.eltRef.nativeElement.getAttribute('infoFields'));
    }
    ngOnInit() { }
}
StocksEditProfileModalButtonComponent.ɵfac = function StocksEditProfileModalButtonComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StocksEditProfileModalButtonComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
StocksEditProfileModalButtonComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StocksEditProfileModalButtonComponent, selectors: [["ycn-stocks-edit-profile-modal-button"]], inputs: { defaultInfoFields: "defaultInfoFields", infoFields: "infoFields" }, standalone: false, decls: 7, vars: 3, consts: [["stocksEditProfileModal", ""], [1, "panel-action"], [1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", 3, "name"], [3, "infoFields", "defaultInfoFields"]], template: function StocksEditProfileModalButtonComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
        i0.ɵɵlistener("click", function StocksEditProfileModalButtonComponent_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r1); const stocksEditProfileModal_r2 = i0.ɵɵreference(6); return i0.ɵɵresetView(stocksEditProfileModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(2, "svg", 3);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "span");
        i0.ɵɵtext(4, "Edit");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(5, "ycn-stocks-edit-profile-modal", 4, 0);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-edit");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("infoFields", ctx.infoFields)("defaultInfoFields", ctx.defaultInfoFields);
    } }, dependencies: [i1.StocksEditProfileModalComponent, i2.IconDirective], encapsulation: 2 });
